const theme = {
	fonts: {
		main: "Rubik, sans-serif"
	},
	colors: {
		dark: "#212121",
		primary: "#2CA8DE"
	},
	fontsize: {
		heading: "56px",
		subHeading: "40px"
	}
};


export default theme
